module.exports = __webpack_public_path__ + "images/emoji/soon.79884ea6350a661da7dd.png";